export default {
  pageDescriptionWithRepair: {
    id: 'no_policies_or_eligible_insurances_page_description_with_repair',
    defaultMessage:
      'You don’t have any active plans right now. If your device is broken, take a look at our On Demand Repair service.',
  },
  pageDescriptionWithoutRepair: {
    id: 'no_policies_or_eligible_insurances_page_description_without_repair',
    defaultMessage: 'You don’t have any active plans right now.',
  },
}
